import { geographyValue } from './datasets/riskDatasets';

export const GRADE_BAND_OPTIONS = [
  { id: 'all', label: 'All grades' },
  { id: 'Elementary', label: 'Elementary' },
  { id: 'Middle', label: 'Middle' },
  { id: 'High', label: 'High' },
];

export const STEADY_OPTIONS = [
  { id: 'both', label: 'Both' },
  { id: 'steady', label: 'Steady State' },
  { id: 'phasing', label: 'Phasing In/Out' },
];

const isYes = (value) => String(value || '').toLowerCase() === 'yes';

export function matchesSteady(school, mode) {
  if (mode === 'steady') return isYes(school?.steadyState);
  if (mode === 'phasing') return isYes(school?.phaseInOut);
  return true;
}

/** A school matches a band when its grade span touches it (K-8 is Elementary and Middle). */
export function matchesGradeBand(school, band) {
  if (!band || band === 'all') return true;
  return (school?.gradeBands || []).includes(band);
}

export function matchesGeography(school, level, value) {
  if (!level || level.id === 'state' || !value) return true;
  return geographyValue(school, level) === value;
}

export function filterSchools(schools, { level, value, steadyMode = 'both', gradeBand = 'all' } = {}) {
  return (schools || []).filter(
    (school) =>
      matchesGeography(school, level, value) &&
      matchesSteady(school, steadyMode) &&
      matchesGradeBand(school, gradeBand)
  );
}

/** Sorted distinct values for a geography level's dropdown. */
export function geographyOptions(schools, level) {
  if (!level || level.id === 'state') return [];
  const values = new Set();
  (schools || []).forEach((school) => {
    const value = geographyValue(school, level);
    if (value) values.add(value);
  });
  return [...values].sort((a, b) => a.localeCompare(b));
}
